import React from "react";

export default function FilterMetricIcon({ type }) {
  if (type === "calendar") {
    return (
      <span className="filter-metric-icon calendar" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M7 3.8v3.4" />
          <path d="M17 3.8v3.4" />
          <path d="M4.8 8.2h14.4" />
          <path d="M6.2 5.6h11.6a2 2 0 0 1 2 2v10.6a2 2 0 0 1-2 2H6.2a2 2 0 0 1-2-2V7.6a2 2 0 0 1 2-2Z" />
          <path d="M8 12h.1" />
          <path d="M12 12h.1" />
          <path d="M16 12h.1" />
          <path d="M8 16h.1" />
          <path d="M12 16h.1" />
        </svg>
      </span>
    );
  }

  if (type === "monetary") {
    return (
      <span className="filter-metric-icon monetary" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M7 5h10" />
          <path d="M7 8.6h10" />
          <path d="M8 5c5.8 0 5.8 7 0 7l6 7" />
        </svg>
      </span>
    );
  }

  return (
    <span className="filter-metric-icon visits" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="M7.2 6.8a2.4 2.4 0 1 0 0-.1Z" />
        <path d="M16.8 17.2a2.4 2.4 0 1 0 0-.1Z" />
        <path d="M9.2 7.2h3.5c2.3 0 3.5.9 3.5 2.5s-1.2 2.5-3.5 2.5h-1.4c-2.2 0-3.3.9-3.3 2.7" />
      </svg>
    </span>
  );
}
